import { FC, ReactNode } from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { Colors } from '../controls/helpers';

interface Props {
    label: string;
    className?: string;
    classes?: Partial<ReturnType<typeof useStyles>>;
    endAdornment?: ReactNode;
}

const WhiteTextBox: FC<Props> = (props) => {
    const { children, className, label, endAdornment } = props;
    const classes = useStyles(props);

    return <Box className={clsx(classes.root, className)}>
        <Typography className={classes.label}>{label}</Typography>
        <Box className={classes.textBox}>
            <Typography className={classes.textBoxValue}>{children}</Typography>
            {endAdornment && <Box className={classes.endAdornment}>{endAdornment}</Box>}
        </Box>
    </Box>
}

const useStyles = makeStyles({
    root: {},
    textBox: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: 52,
        backgroundColor: Colors.White,
        padding: '0 10px 0 10px',
        borderRadius: '0.75rem',
        border: `1px solid ${Colors.Grey}`
    },
    textBoxValue: {
        color: Colors.DarkGrey
    },
    label: {
        color: Colors.DarkGrey,
        fontWeight: 500
    },
    endAdornment: {
        marginLeft: 'auto',
        display: 'flex'
    }
}, { name: 'WhiteTextBox' });

export default WhiteTextBox;
